import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axiosInstance from './AxiosInstance';
import { Method } from 'axios';

const axiosBaseQuery = async ({ url, method, data }: { url: string; method: Method; data?: any }) => {
  try {
    const response = await axiosInstance({ url, method, data });
    return { data: response.data };
  } catch (error) {
    const err = error as { response?: { status: number; data: any } };
    return { error: { status: err.response?.status, data: err.response?.data } };
  }
};

const AppApi = createApi({
  reducerPath: 'AppApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['CustomerDashboard',"AdminDashboard"],
  endpoints: () => ({}),
});

export default AppApi;
